<div class="margin-top-less-10">
    <router-outlet></router-outlet>
</div>
